import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89648584"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "ButtonText" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "lnr-sync PendingIcon" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submitButtonClicked && _ctx.submitButtonClicked(...args))),
    class: _normalizeClass([_ctx.pending ? 'Pending' : '', "SubmitButton"]),
    "data-cy": "SubmitButton",
    type: "submit"
  }, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.buttonText[_ctx.type]), 1 /* TEXT */),
    _hoisted_3
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}